export default {
  region: "eu-west-1",
  IdentityPoolId: "eu-west-1_cqBiqDTb1",
  UserPoolId: "eu-west-1:731725683348",
  ClientId: "2pe012gc621jmrdh3mj7aurdbe",
  Sites: ["voiceplus", "lookupengine"],
};
